<template>
  <div v-if="model">
    <rkm-area no-margin-top title="Filtros" type="fieldset">
      <rkm-form ref="Form">
        <rkm-row>
          <rkm-col cols="5">
            <rkm-form-select
              show-default-option
              default-option-text="TODOS"
              label="Unidade"
              :options="form.unidades"
              v-model="model.unidade"
              @change="getAreas"
              text-field="nome"
              value-field="id"
            />
          </rkm-col>
          <rkm-col cols="3">
            <rkm-form-select
              showDefaultOption
              default-option-text="TODOS"
              label="Domicílio"
              @change="getAreas"
              :options="form.domicilios"
              v-model="model.domicilio"
              text-field="descricao"
            />
          </rkm-col>
          <rkm-col cols="2">
            <rkm-form-select
              :disabled="model.domicilio === false"
              show-default-option
              default-option-text="TODOS"
              label="Área"
              text-field="descricao"
              value-field="id"
              :options="form.areas"
              v-model="model.area"
              @change="getMicroareas"
            />
          </rkm-col>
          <rkm-col cols="2">
            <rkm-form-select
              :disabled="model.domicilio === false"
              show-default-option
              default-option-text="TODOS"
              label="Microárea"
              :options="form.microareas"
              v-model="model.microarea"
              text-field="descricao"
              value-field="descricao"
            />
          </rkm-col>
          <rkm-col>
            <rkm-button :label="false" color="primary" @click="search"
              >Buscar</rkm-button
            >
            <rkm-button :label="false" @click="reset">Limpar</rkm-button>
          </rkm-col>
        </rkm-row>
      </rkm-form>
    </rkm-area>

    <rkm-area no-margin-top title="Resultado" v-if="mostraAreaResultado">
      <template v-slot:trailing>
        <rkm-button
          :disabled="items.length === 0"
          @click="print"
          color="info"
          small
          title="Imprimir"
        >
          <rkm-icon icon="print" />
        </rkm-button>

        <rkm-button
          :disabled="items.length === 0"
          @click="exportTo"
          color="info"
          small
          title="Exportar"
        >
          <rkm-icon icon="file-export" />
        </rkm-button>
      </template>

      <rkm-table :fields="fields" :items="items" sort-by="agendar.data">
        <template v-if="model.domicilio !== false" #thead-top>
          <rkm-tr>
            <rkm-th colspan="2"></rkm-th>
            <rkm-th :colspan="colunasDinamicas().length" class="text-center"
              >Microárea(s)</rkm-th
            >
            <rkm-th v-if="model.domicilio != true && !model.microarea"></rkm-th>
          </rkm-tr>
        </template>

        <template v-slot:cell(areas)="{ item }">
          <div v-for="(area, i) in item.areas" :key="i">
            <div
              v-if="
                model.area === null &&
                !model.microarea &&
                area.microareas.length > 0
              "
            >
              <hr v-if="i > 0" />
              {{ area.areaDescricao }}
            </div>

            <div
              v-if="
                model.area === null &&
                model.microarea &&
                area.microareas.length > 0
              "
            >
              <hr
                v-if="
                  i > 0 &&
                  item.areas.filter((a) => a.microareas.length > 0).length > 1
                "
              />

              {{ area.areaDescricao }}
            </div>

            <div v-if="model.area && model.area == area.areaId">
              {{ area.areaDescricao }}
            </div>
          </div>
        </template>

        <template
          v-for="column in colunasDinamicas()"
          v-slot:[`cell(${column.key})`]="{ item }"
        >
          <div :key="column.key" class="text-center">
            <div v-for="(area, areaIndex) in item.areas" :key="areaIndex">
              <!-- Coluna total de microárea -->
              <div
                v-if="
                  model.area == area.areaId &&
                  column.key == 'total' &&
                  model.microarea === null
                "
              >
                {{ area.areaTotalPacientes }}
              </div>
              <div
                v-if="
                  column.key == 'total' &&
                  model.area === null &&
                  model.microarea === null
                "
              >
                <hr v-if="areaIndex > 0" />
                {{ area.areaTotalPacientes }}
              </div>
              <div
                v-for="(microarea, microareaIndex) in area.microareas"
                :key="microareaIndex"
              >
                <!-- Coluna de microáreas quando não houver filtro de área, mas houver de microarea -->
                <div>
                  <div
                    v-if="
                      model.area === null &&
                      microarea.microareaDescricao == column.key
                    "
                  >
                    <hr
                      v-if="
                        areaIndex > 0 &&
                        item.areas.filter((a) => a.microareas.length > 0)
                          .length > 1
                      "
                    />
                    <a
                      href="#"
                      v-if="
                        microarea.microareaTotalPacientes &&
                        column.key != 'total'
                      "
                      class="font-weight-bold text-primary"
                      @click.prevent="abrirModal(microarea)"
                    >
                      {{ microarea.microareaTotalPacientes }}
                    </a>
                  </div>
                  <span
                    v-if="
                      model.area === null &&
                      areaIndex == 0 &&
                      column.key != 'total' &&
                      area.microareas &&
                      microarea.microareaDescricao != column.key
                    "
                  >
                    0
                  </span>
                </div>

                <!-- Coluna de microáreas quando houver filtro de área -->
                <div>
                  <div
                    v-if="
                      model.area == area.areaId &&
                      microarea.microareaDescricao == column.key
                    "
                  >
                    <a
                      href="#"
                      v-if="
                        microarea.microareaTotalPacientes &&
                        column.key != 'total'
                      "
                      class="font-weight-bold text-primary"
                      @click.prevent="abrirModal(microarea)"
                    >
                      {{ microarea.microareaTotalPacientes }}
                    </a>
                  </div>
                  <span
                    v-if="
                      model.area == area.areaId &&
                      areaIndex == 0 &&
                      column.key != 'total' &&
                      area.microareas &&
                      microarea.microareaDescricao != column.key
                    "
                  >
                    0
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-slot:[`cell(pacientesForaArea)`]="{ value }">
          <a
            href="#"
            v-if="value.totalForaArea"
            class="font-weight-bold text-primary"
            @click.prevent="abrirModal(value, false)"
            >{{ value.totalForaArea }}
          </a>
          <div v-else>0</div>
        </template>
        <template v-slot:custom-foot v-if="total">
          <rkm-tr>
            <rkm-th :colspan="columns.length">
              <rkm-row>
                <rkm-col>Total</rkm-col>
                <rkm-col class="text-center" cols="1">{{ total }}</rkm-col>
              </rkm-row>
            </rkm-th>
          </rkm-tr>
        </template>
      </rkm-table>
    </rkm-area>

    <rkm-area
      title="Totais"
      type="fieldset"
      no-margin-top
      v-if="mostraAreaResultado"
    >
      <rkm-row>
        <rkm-col cols="3">
          Unidade(s)
          <rkm-alert color="secondary">
            <strong> {{ totalizadores.unidades }} </strong>
          </rkm-alert>
        </rkm-col>
        <rkm-col cols="3">
          Dentro de área
          <rkm-alert color="secondary">
            <strong> {{ totalizadores.dentroArea }} </strong>
          </rkm-alert>
        </rkm-col>
        <rkm-col cols="3">
          Fora de área
          <rkm-alert color="secondary">
            <strong> {{ totalizadores.foraArea }} </strong>
          </rkm-alert>
        </rkm-col>
        <rkm-col cols="3">
            Dentro + Fora de área
          <rkm-alert color="secondary">
            <strong>
              {{ totalizadores.dentroArea + totalizadores.foraArea }}
            </strong>
          </rkm-alert>
        </rkm-col>
      </rkm-row>
    </rkm-area>

    <Modal ref="Modal" />
  </div>
</template>

  <script>
import { mapActions } from "vuex";
import { repository, error, data, object, stringCase, file } from "@/mixins";
import Modal from "./components/Modal";

export default {
  components: {
    Modal,
  },
  computed: {
    fields() {
      const staticColumns = this.columns.filter(
        (c) => c.fixed || this.selectedCols.includes(c.key)
      );

      const dynamicColumns = this.colunasDinamicas();

      const index =
        this.model.domicilio === true || this.model.microarea
          ? 2
          : staticColumns.findIndex((c) => c.key === "pacientesForaArea");

      staticColumns.splice(index, 0, ...dynamicColumns);

      return staticColumns;
    },
  },
  created() {
    this.repositories = {
      relatorioCadastroConsistente: this.getConectaSusRepository(
        "atencaoBasica.relatorioCadastroConsistente"
      ),
      impressao: this.getConectaSusRepository("impressao.atencaoBasica"),
      exportacao: this.getConectaSusRepository("exportacao.atencaoBasica"),
    };
    this.load();
  },
  data() {
    return {
      model: {
        unidade: null,
        domicilio: null,
        area: null,
        microarea: null,
        pacienteIds: null,
      },
      form: {
        unidades: null,
        domicilios: [
          {
            descricao: "Dentro de área",
            value: true,
          },
          {
            descricao: "Fora de área",
            value: false,
          },
        ],
        areas: null,
        microareas: null,
      },
      items: [],
      selectedAll: true,
      mostraAreaResultado: false,
      total: null,
      selectedCols: ["areas", "pacientesForaArea"],
      totalizadores: {
        unidades: 0,
        dentroArea: 0,
        foraArea: 0,
      },
      todasMicroareasVisiveis: [],
      columns: [
        {
          key: "unidadeNome",
          label: "Unidade",
          sortable: true,
          fixed: true,
        },
        {
          key: "areas",
          label: "Área / INE",
          sortable: true,
        },
        {
          key: "pacientesForaArea",
          label: "Fora de Área",
          sortable: true,
        },
      ],
      pacientesSelecionados: null,
    };
  },
  methods: {
    ...mapActions(["setLoading", "unsetLoading"]),
    load() {
      this.setLoading();
      this.repositories.relatorioCadastroConsistente
        .index()
        .then(({ data }) => {
          if (data.form) this.form = data.form;
          if (data.model) this.model = data.model;
          this.model.domicilio = null;
        })
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
      this.getUnidades();
      this.getAreas();
      this.getMicroareas();
    },
    search() {
      this.setLoading();
      this.repositories.relatorioCadastroConsistente
        .list({
          unidade: this.model.unidade,
          domicilio: this.model.domicilio,
          area: this.model.area,
          microarea: this.model.microarea,
        })
        .then(({ data }) => {
          this.items = data.consulta;
          this.todasMicroareasVisiveis = data.todasMicroareas;
          this.totalizadores = data.totalizadores;
          this.mostraAreaResultado = true;
        })
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    async abrirModal(dados, estaDentroDeArea = true) {
      const filtros = {
        unidade: this.form.unidades.find((q) => q.id === dados.unidadeId).nome,
        domicilio: estaDentroDeArea ? "Dentro de Área" : "Fora de Área",
        areaIne: "-",
        microarea: "-",
      };

      if (estaDentroDeArea) {
        filtros.areaIne = this.form.areas.find(
          (q) => q.id === dados.areaId
        ).descricao;

        filtros.microarea =
          this.form.microareas.find(
            (q) => q.descricao === dados.microareaDescricao
          ).descricao + "";
      }

      const pacienteIds = estaDentroDeArea
        ? dados.microareaPacientesIds
        : dados.foraAreaPacientesId;

      const pacientes = await this.getPacientes(pacienteIds);

      this.$refs.Modal.open(filtros, pacientes, pacienteIds);
    },
    colunasDinamicas() {
      if (this.model.domicilio === false) {
        return [{}];
      }
      return this.todasMicroareasVisiveis.map((col) => {
        return {
          key: `${col}`,
          label: col === "total" ? "Total" : col,
          fixed: true,
          sortable: false,
          class: "text-center",
        };
      });
    },
    getUnidades() {
      this.setLoading();
      this.repositories.relatorioCadastroConsistente
        .getUnidades()
        .then(({ data }) => {
          this.form.unidades = data;
          this.model.area = null;
          this.model.domicilio = null;
          this.model.microarea = null;
        })
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    getAreas() {
      this.setLoading();
      this.model.area = null;
      this.model.microarea = null;
      this.repositories.relatorioCadastroConsistente
        .getAreas({
          unidade: this.model.unidade,
        })
        .then(({ data }) => {
          this.form.areas = data;
        })
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
      this.getMicroareas();
    },
    getMicroareas() {
      this.setLoading();
      this.model.microarea = null;
      this.repositories.relatorioCadastroConsistente
        .getMicroareas({
          unidade: this.model.unidade,
          area: this.model.area,
        })
        .then(({ data }) => {
          this.form.microareas = data;
        })
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    getPacientes(pacientesId) {
      this.setLoading();
      return this.repositories.relatorioCadastroConsistente
        .getPacientes({
          pacientes: pacientesId,
        })
        .then(({ data }) => {
          return data;
        })
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    reset() {
      this.items = [];
      this.model.unidade = null;
      this.model.domicilio = null;
      this.model.area = null;
      this.model.microarea = null;
      this.mostraAreaResultado = false;
    },
    print() {
      this.setLoading();
      this.repositories.impressao
        .relatorioCadastroConsistente(this.prepareDataWithColumns())
        .then(({ data, headers }) =>
          this.openFile(data, headers["content-type"])
        )
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    exportTo() {
      this.setLoading();
      this.repositories.exportacao
        .relatorioCadastroConsistente(this.prepareDataWithColumns())
        .then(({ data, headers }) =>
          this.openFile(data, headers["content-type"])
        )
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    prepareDataWithColumns() {
      const data = this.prepareData();
      const fields = this.fields.filter((item) => item.key !== undefined);
      data.selectedCols = fields.map((f) => {
        return {
          key: this.camelToSnake(f.key),
          label: f.label,
          class: f.class,
        };
      });

      return data;
    },
    prepareData() {
      const data = this.clone(this.model);
      return this.camelObjectKeysToSnakeRecursive(data);
    },
    selectAll(selected) {
      this.selectedCols = selected ? this.columns.map((c) => c.key) : [];
    },
  },
  mixins: [repository, error, data, object, stringCase, file],
  watch: {
    model: {
      handler() {
        this.mostraAreaResultado = false;
      },
      deep: true,
    },
    "model.domicilio"(value) {
      if (value === false) {
        this.selectedCols = ["pacientesForaArea"];
        return;
      }

      if (value === null) {
        this.selectedCols = ["areas", "pacientesForaArea"];
        return;
      }

      this.selectedCols = ["areas"];
    },
    "model.microarea"(value) {
      if (value) {
        this.selectedCols = ["areas"];
        return;
      }

      if (!value && this.model.domicilio !== true) {
        this.selectedCols = ["areas", "pacientesForaArea"];
      }
    },
  },
};
</script>
